module.exports = __webpack_public_path__ + "img/index_sence_img2.038bbc95.png";